document.querySelectorAll('.drag-slider').forEach((el) => {
  if (!el.classList.contains('is-init')) {
    el.classList.add('is-init');

    const slider = el.querySelector('.drag-slider-wrapper');
    const buttonsContainer = el.parentElement.querySelector(
      '.drag-slider-buttons'
    );
    const prevButton = buttonsContainer?.querySelector(
      '.drag-slider-button.prev'
    );
    const nextButton = buttonsContainer?.querySelector(
      '.drag-slider-button.next'
    );

    let velocity = 0;
    let animationFrame;
    let isDown = false;
    let startX;
    let startY;
    let scrollLeft;
    const tolerance = 10;
    let isMoving = false;

    const dragSlidesArr = slider.querySelectorAll('.drag-slide');

    const isFirefox = navigator.userAgent.toLowerCase().includes('firefox');
    const isSafari =
      navigator.userAgent.toLowerCase().includes('safari') &&
      !navigator.userAgent.toLowerCase().includes('chrome');

    let preventClick = false;

    // Функция для получения ширины одного слайда
    const getSlideWidth = () => {
      const firstSlide = dragSlidesArr[0];
      if (!firstSlide) return 0;
      const computedStyle = window.getComputedStyle(firstSlide);
      const width = firstSlide.offsetWidth;
      const marginLeft = parseFloat(computedStyle.marginLeft) || 0;
      const marginRight = parseFloat(computedStyle.marginRight) || 0;
      return width + marginLeft + marginRight;
    };

    // Функция для плавного скролла
    const smoothScrollTo = (targetPosition, duration = 500) => {
      const startPosition = slider.scrollLeft;
      const distance = targetPosition - startPosition;
      const startTime = performance.now();

      // Отключаем scroll-snap на время анимации
      slider.style.scrollSnapType = 'none';

      const animateScroll = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);

        // Easing функция для плавности
        const easeInOutCubic =
          progress < 0.5
            ? 4 * progress * progress * progress
            : (progress - 1) * (2 * progress - 2) * (2 * progress - 2) + 1;

        slider.scrollLeft = startPosition + distance * easeInOutCubic;

        if (progress < 1) {
          requestAnimationFrame(animateScroll);
        } else {
          // Возвращаем scroll-snap после анимации
          slider.style.scrollSnapType = '';
        }
      };

      requestAnimationFrame(animateScroll);
    };

    // Функция для обновления состояния кнопок
    const updateButtonsState = () => {
      if (!buttonsContainer) return;

      const isAtStart = slider.scrollLeft <= 10;
      const isAtEnd =
        slider.scrollLeft >= slider.scrollWidth - slider.clientWidth - 10;

      prevButton?.classList.toggle('disabled', isAtStart);
      nextButton?.classList.toggle('disabled', isAtEnd);
    };

    // Обработчики кнопок
    if (prevButton) {
      prevButton.addEventListener('click', (e) => {
        e.preventDefault();
        if (prevButton.classList.contains('disabled')) return;

        const slideWidth = getSlideWidth();
        const currentScroll = slider.scrollLeft;
        const targetScroll = Math.max(0, currentScroll - slideWidth);

        smoothScrollTo(targetScroll);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', (e) => {
        e.preventDefault();
        if (nextButton.classList.contains('disabled')) return;

        const slideWidth = getSlideWidth();
        const currentScroll = slider.scrollLeft;
        const maxScroll = slider.scrollWidth - slider.clientWidth;
        const targetScroll = Math.min(maxScroll, currentScroll + slideWidth);

        smoothScrollTo(targetScroll);
      });
    }

    // Отслеживание скролла для обновления кнопок
    let scrollTimeout;
    slider.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        updateButtonsState();
      }, 10);
    });

    // Инициализация состояния кнопок
    setTimeout(() => {
      updateButtonsState();
    }, 100);

    // Оригинальная логика драга остается без изменений
    const start = (x, y) => {
      isDown = true;
      isMoving = false;
      preventClick = false;
      slider.classList.add('active');
      startX = x - slider.getBoundingClientRect().left;
      startY = y;
      scrollLeft = slider.scrollLeft;
      slider.style.scrollSnapType = 'none';
    };

    const move = (x, y) => {
      if (!isDown) return;
      const deltaX = Math.abs(x - startX);
      const deltaY = Math.abs(y - startY);
      if (deltaX > tolerance || deltaY > tolerance) {
        isMoving = true;
        preventClick = true;
      }
      const dist = x - startX;
      const newScrollLeft = scrollLeft - dist;
      velocity = newScrollLeft - slider.scrollLeft;
      slider.scrollLeft = newScrollLeft;

      // Обновляем кнопки во время драга
      updateButtonsState();
    };

    const end = (e) => {
      if (!isDown) return;
      isDown = false;
      isMoving = false;
      slider.classList.remove('active');
      slider.style.scrollSnapType = '';

      if (!preventClick) {
        let target;
        if (e.clientX !== undefined && e.clientY !== undefined) {
          target = document
            .elementFromPoint(e.clientX, e.clientY)
            ?.closest('a');
        } else if (e.changedTouches && e.changedTouches[0]) {
          target = document
            .elementFromPoint(
              e.changedTouches[0].clientX,
              e.changedTouches[0].clientY
            )
            ?.closest('a');
        }

        if (target) {
          window.location.href = target.getAttribute('href');
        }
      }

      cancelAnimationFrame(animationFrame);
      const friction = 0.95;
      const minVelocity = 0.5;

      const inertia = () => {
        if (Math.abs(velocity) > minVelocity) {
          slider.scrollLeft += velocity;
          velocity *= friction;
          animationFrame = requestAnimationFrame(inertia);
          updateButtonsState();
        }
      };

      inertia();

      preventClick = false;
    };

    const handleGlobalMouseUp = () => {
      if (isDown) {
        isDown = false;
        isMoving = false;
        slider.classList.remove('active');
        slider.style.scrollSnapType = '';
        preventClick = true;
      }
    };

    if (!isFirefox) {
      slider.addEventListener('pointerdown', (e) => {
        start(e.pageX, e.pageY);
        slider.setPointerCapture(e.pointerId);
      });

      slider.addEventListener('pointermove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        move(e.pageX, e.pageY);
      });

      slider.addEventListener('pointerup', (e) => {
        end(e);
        slider.releasePointerCapture(e.pointerId);
      });

      slider.addEventListener('pointercancel', end);
    }

    if (isFirefox) {
      let isDragging = false;

      const handleMouseMoveFirefox = (e) => {
        if (isDown) {
          const deltaX = Math.abs(e.pageX - startX);
          const deltaY = Math.abs(e.pageY - startY);
          if (deltaX > tolerance || deltaY > tolerance) {
            isDragging = true;
            slider.querySelectorAll('a').forEach((link) => {
              link.style.pointerEvents = 'none';
            });
          }
          const dist = e.pageX - startX;
          slider.scrollLeft = scrollLeft - dist;
          updateButtonsState();
        }
      };

      const handleMouseUpFirefox = (e) => {
        end(e);
        window.removeEventListener('mouseup', handleMouseUpFirefox);
        window.removeEventListener('mousemove', handleMouseMoveFirefox);

        setTimeout(() => {
          slider.querySelectorAll('a').forEach((link) => {
            link.style.pointerEvents = '';
          });
          isDragging = false;
        }, 100);
      };

      slider.addEventListener('mousedown', (e) => {
        if (e.button === 0) {
          start(e.pageX, e.pageY);
          isDragging = false;
          window.addEventListener('mouseup', handleMouseUpFirefox);
          window.addEventListener('mousemove', handleMouseMoveFirefox);
        }
      });

      slider.addEventListener('touchstart', (e) => {
        if (e.touches.length > 0) start(e.touches[0].pageX, e.touches[0].pageY);
      });

      slider.addEventListener('touchmove', (e) => {
        if (e.touches.length > 0) move(e.touches[0].pageX, e.touches[0].pageY);
      });

      slider.addEventListener('touchend', (e) => {
        end(e);
      });

      slider.addEventListener('dragstart', (e) => {
        e.preventDefault();
      });
    }

    if (isSafari) {
      let isDragging = false;

      const handleMouseMoveSafari = (e) => {
        if (isDown) {
          const deltaX = Math.abs(e.pageX - startX);
          const deltaY = Math.abs(e.pageY - startY);
          if (deltaX > tolerance || deltaY > tolerance) {
            isDragging = true;
            slider.querySelectorAll('a').forEach((link) => {
              link.style.pointerEvents = 'none';
            });
          }
          const dist = e.pageX - startX;
          slider.scrollLeft = scrollLeft - dist;
          updateButtonsState();
        }
      };

      const handleMouseUpSafari = (e) => {
        end(e);
        window.removeEventListener('mouseup', handleMouseUpSafari);
        window.removeEventListener('mousemove', handleMouseMoveSafari);

        setTimeout(() => {
          slider.querySelectorAll('a').forEach((link) => {
            link.style.pointerEvents = '';
          });
          isDragging = false;
        }, 100);
      };

      slider.addEventListener('mousedown', (e) => {
        if (e.button === 0) {
          start(e.pageX, e.pageY);
          isDragging = false;
          window.addEventListener('mouseup', handleMouseUpSafari);
          window.addEventListener('mousemove', handleMouseMoveSafari);
        }
      });
    }

    slider.querySelectorAll('a').forEach((link) => {
      link.addEventListener('dragstart', (e) => {
        e.preventDefault();
      });
    });

    // Оригинальная логика высоты слайдов
    let maxHeight = 0;

    dragSlidesArr.forEach((slide) => {
      const height = slide.offsetHeight;
      if (height > maxHeight) {
        maxHeight = height;
      }
    });

    dragSlidesArr.forEach((slide) => {
      slide.style.minHeight = maxHeight + 'px';
    });

    // Обновление кнопок при изменении размера окна
    window.addEventListener('resize', () => {
      setTimeout(() => {
        updateButtonsState();
      }, 100);
    });
  }
});
